module.exports = __webpack_public_path__ + "img/BobDavis.2b1385d3.jpg";